import { render } from "./distributor_stock.vue?vue&type=template&id=4fbf9695&scoped=true"
import script from "./distributor_stock.vue?vue&type=script&lang=js"
export * from "./distributor_stock.vue?vue&type=script&lang=js"

import "./distributor_stock.vue?vue&type=style&index=0&id=4fbf9695&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbf9695"]])

export default __exports__